import React from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "../../../../components/Modal";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import checkmarkIcon from "url:shared-assets/icons/green/badge-check-filled.svg";

interface CancellationModalProps {
  onClose: () => void;
  isOpen: boolean;
  coachName: string;
}

const SuccessfullyCancelledModal: React.FC<CancellationModalProps> = ({
  onClose,
  isOpen,
  coachName,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader onClose={onClose}>
        <div className="z-title1">{t("meeting-cancelled")}</div>
      </ModalHeader>
      <ModalBody>
        <div className="flex flex-col justify-between gap-3 ">
          <div className="flex flex-row justify-center">
            <img
              src={checkmarkIcon}
              alt="Cancel meeting"
              className="w-12 h-12 my-3"
            />
          </div>
          <p className="text-normal text-base">
            {t("meeting-with-coach-cancelled", { coach: coachName })}
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <CustomButton onClick={onClose}>{t("close")}</CustomButton>
      </ModalFooter>
    </Modal>
  );
};

export default SuccessfullyCancelledModal;
